// extracted by mini-css-extract-plugin
export default {"title":"CookieBanner-module__title-xJq_","banner":"CookieBanner-module__banner-Ijkh","text":"CookieBanner-module__text-Gk5c","actions":"CookieBanner-module__actions-cMtj"};